import styled from "styled-components";
import {NavLink} from "react-router-dom";
import {BaseLinkStyles} from "./BaseLink";
import {linkStyles} from "./linkStyles";

export const TertiaryLink = styled(NavLink)`
	${BaseLinkStyles};
	${({theme}) => linkStyles(theme.button.tertiary)}
`;

export const TertiaryExternalLink = styled.a`
	${BaseLinkStyles};
	${({theme}) => linkStyles(theme.button.tertiary)}
`;

TertiaryExternalLink.defaultProps = {
	target: "_blank",
	rel: "noreferrer noopener",
};
